import { render, staticRenderFns } from "./ListRequest.vue?vue&type=template&id=620b3495"
import script from "./ListRequest.vue?vue&type=script&lang=js"
export * from "./ListRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports